import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import PrayerRequests from "@/pages/PrayerRequests";
import Devotionals from "@/pages/Devotionals";
import DevotionalDetail from "@/pages/DevotionalDetail";
import BibleStudies from "@/pages/BibleStudies";
import BiblePromises from "@/pages/BiblePromises";
import Videos from "@/pages/Videos";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "auto" }); }, [pathname]);
  return null;
}

function SiteRoutes() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/devotionals" element={<Devotionals />} />
        <Route path="/devotionals/:slug" element={<DevotionalDetail />} />
        <Route path="/bible-studies" element={<BibleStudies />} />
        <Route path="/bible-promises" element={<BiblePromises />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/prayer-requests" element={<PrayerRequests />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<SiteRoutes />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
